import type { SmartFormAddress } from "./SmartFormAddress.js";

export enum SmartFormCompanyValidationResultType {
	NOTHING = "NOTHING",
	HIT = "HIT",
}

export enum SmartFormCompanyStatus {
	NOT_ACTIVE = "NOT_ACTIVE",
	ACTIVE = "ACTIVE",
}

export interface SmartFormCompany {
	NAME: string;
	STATUS: SmartFormCompanyStatus;
	ADDRESS_CITY: string;
	ADDRESS_CITY_EXTENDED: string;
	ADDRESS_NUMBER: string;
	ADDRESS_STREET: string;
	ADDRESS_STREET_AND_NUMBER: string;
	ADDRESS_WHOLE_ADDRESS: string;
	ADDRESS_ZIP: string;
	CREATION_DATE: string;
	DISSOLUTION_DATE: string;
	LEGAL_FORM: string;
	REGISTRATION_NUMBER: string;
	SIZE: string;
	VAT_NUMBER: string;
}

export enum SmartFormAddressValidationResultType {
	NOTHING = "NOTHING",
	INSUFFICIENT_DATA = "INSUFFICIENT_DATA",
	MANY = "MANY",
	HIT = "HIT",
	TOOMANY = "TOOMANY",
}

export interface SmartFormAddressResult {
	instanceId: string;
	result: {
		type: SmartFormAddressValidationResultType;
		addressArray: SmartFormAddress[];
	};
}

export interface SmartFormCompanyResult {
	result: {
		type: SmartFormCompanyValidationResultType;
		companyArray: SmartFormCompany[];
	};
}

export interface SmartFormInstance {
	getId(): string;
	addressControl: {
		addValidationCallback(callback: (result: SmartFormAddressResult) => void): void;
	};
	companyControl: {
		isCompanyValid(): boolean;
		addValidationCallback(callback: (result: SmartFormCompanyResult) => void): void;
	};
}

export interface ISmartform {
	beforeInit(callback: () => void): void;
	afterInit(callback: () => void): void;
	isCompanyServiceEnabled(): boolean;
	getInstance(id?: string): SmartFormInstance | undefined;
	getInstanceIds(): string[];
	setClientId(clientId: string): void;
	enableSetAutocomplete(enable: boolean): void;
	unbindForm(instanceId: string): void;
	rebindAllForms(doneCallback?: () => Promise<void> | void): void;
}
